import { EAdSenseProvider } from '@domain/enums/common/EAdSense';

export const getProviderName = (provider: string): string | undefined =>
  ({
    facebook_report: 'Facebook',
    taboola_report: 'Taboola',
    google_report: 'Google',
    taboola_tax_report: 'Taboola (Impostos)'
  }[provider]);

export const getAdSenseProvider = (provider: string): EAdSenseProvider | undefined =>
  ({
    facebook_report: EAdSenseProvider.FACEBOOK,
    taboola_report: EAdSenseProvider.TABOOLA,
    google_report: EAdSenseProvider.GOOGLE,
    taboola_tax_report: EAdSenseProvider.TABOOLA_TAX
  }[provider]);

export const getMarketingReportName = (provider: EAdSenseProvider): string | undefined =>
  ({
    FACEBOOK: 'facebook_report',
    TABOOLA: 'taboola_report',
    GOOGLE: 'google_report',
    TIKTOK: 'tiktok_report',
    FACEBOOK_TAX: 'facebook_tax_report',
    TABOOLA_TAX: 'taboola_tax_report'
  }[provider]);

export const getAdSenseProviderName = (provider: EAdSenseProvider): string | undefined =>
  ({
    FACEBOOK: 'Facebook',
    TABOOLA: 'Taboola',
    GOOGLE: 'Google',
    TIKTOK: 'Tiktok',
    FACEBOOK_TAX: 'Facebook (Impostos)',
    TABOOLA_TAX: 'Taboola (Impostos)'
  }[provider]);
